import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBigcartelComponent } from './simple-icons-bigcartel.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBigcartelComponent ],
    exports:      [ SimpleIconsBigcartelComponent ],
    bootstrap:    []
})
export class SimpleIconsBigcartelModule {}
